// Registrierung „Erinnerungen" für die Shell (Integrator hängt die Arrays/den Watcher in extras/index.tsx ein).
import type { ExtraMenuItem, ExtraRoute } from '../index';
import { RemindersPage } from './RemindersPage';
import { RemindMeDialog } from './RemindMeDialog';

export { RemindersPage } from './RemindersPage';
export { RemindMeDialog } from './RemindMeDialog';
/** Global mounten (extraGlobals): Toasts bei Fälligkeit. */
export { ReminderWatcher } from './ReminderWatcher';
export { handleReminderNotification, REMINDERS_KEY, remindersListKey } from './realtime';

export const remindersRoutes: ExtraRoute[] = [{ path: '/reminders', element: RemindersPage }];

export const remindersMenuItems: ExtraMenuItem[] = [
  { id: 'remind-me', label: 'Erinnere mich', slot: 'messageMenu', component: RemindMeDialog, display: 'dialog' },
  { id: 'reminders', label: 'Erinnerungen', slot: 'userMenu', to: '/reminders' },
];
